import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import CommonSelect from '../../../form-components/CommonSelect';
import { STATUS_OPTIONS, PLAN_TYPE_OPTIONS } from './corpExcelUploadOptions';

const TableScroll = styled(Box)({
  overflowX: 'auto',
  maxHeight: '360px',
  border: '1px solid #e9ecef',
  borderRadius: '8px',
});

const SummaryLine = styled(Typography)({
  fontSize: '13px',
  fontWeight: 600,
  marginBottom: '8px',
});

const Table = styled('table')({
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: '12px',
  whiteSpace: 'nowrap',
});

const Th = styled('th')({
  textAlign: 'left',
  padding: '8px 10px',
  background: '#f8f9fa',
  color: '#333',
  fontWeight: 600,
  borderBottom: '1px solid #e9ecef',
  position: 'sticky',
  top: 0,
});

const Td = styled('td')(({ isError }) => ({
  padding: '8px 10px',
  borderBottom: '1px solid #f1f3f5',
  color: isError ? '#dc2626' : '#333',
}));

const Row = styled('tr')(({ isError }) => ({
  background: isError ? '#fff5f5' : '#fff',
}));

const StatusChip = styled('span')(({ isError }) => ({
  display: 'inline-block',
  padding: '2px 8px',
  borderRadius: '4px',
  fontSize: '11px',
  fontWeight: 600,
  color: isError ? '#dc2626' : '#0F7F85',
  background: isError ? '#fee2e2' : '#e6f4f1',
}));

const ExcludedBox = styled(Box)({
  padding: '10px 12px',
  background: '#f8f9fa',
  borderRadius: '8px',
  marginBottom: '12px',
  fontSize: '12px',
  color: '#6b7280',
});

const CorpExcelUploadPreviewTable = ({ excluded, rows, onRowChange, disabled }) => (
  <Box>
    {excluded.length > 0 && (
      <ExcludedBox>
        엑셀 작성안내 규칙에 따라 {excluded.length}행이 자동 제외되었습니다 (지점명이 '-' 또는 '지부'인 행).
        {' '}
        {excluded.map(row => `${row.rowNumber}행`).join(', ')}
      </ExcludedBox>
    )}

    <SummaryLine>
      등록 대상 {rows.length}행 (정상 {rows.filter(r => r.errors.length === 0).length}행 / 오류{' '}
      {rows.filter(r => r.errors.length > 0).length}행)
    </SummaryLine>

    <TableScroll>
      <Table>
        <thead>
          <tr>
            <Th>상태</Th>
            <Th>행</Th>
            <Th>지점명</Th>
            <Th>대표자명</Th>
            <Th>사업자번호</Th>
            <Th>주소</Th>
            <Th>우편번호</Th>
            <Th>시군구</Th>
            <Th>업태</Th>
            <Th>휴대폰</Th>
            <Th>아이디</Th>
            <Th>계정상태</Th>
            <Th>요금제</Th>
            <Th>오류 사유</Th>
          </tr>
        </thead>
        <tbody>
          {rows.map(row => {
            const isError = row.errors.length > 0;
            return (
              <Row key={row.rowNumber} isError={isError}>
                <Td isError={isError}>
                  <StatusChip isError={isError}>{isError ? '오류' : '정상'}</StatusChip>
                </Td>
                <Td isError={isError}>{row.rowNumber}</Td>
                <Td isError={isError}>{row.branchName}</Td>
                <Td isError={isError}>{row.representativeName}</Td>
                <Td isError={isError}>{row.businessNumber}</Td>
                <Td isError={isError}>{row.address}</Td>
                <Td isError={isError}>{row.postalCode || '-'}</Td>
                <Td isError={isError}>{row.city || '-'}</Td>
                <Td isError={isError}>{row.businessType || '-'}</Td>
                <Td isError={isError}>{row.phoneNumber || '-'}</Td>
                <Td isError={isError}>{row.username}</Td>
                <Td isError={isError}>
                  <CommonSelect
                    size="small"
                    width={100}
                    value={row.status}
                    onChange={e => onRowChange(row.rowNumber, 'status', e.target.value)}
                    options={STATUS_OPTIONS}
                    disabled={disabled}
                  />
                </Td>
                <Td isError={isError}>
                  <CommonSelect
                    size="small"
                    width={90}
                    value={row.planType}
                    onChange={e => onRowChange(row.rowNumber, 'planType', e.target.value)}
                    options={PLAN_TYPE_OPTIONS}
                    disabled={disabled}
                  />
                </Td>
                <Td isError={isError}>{row.errors.join(', ')}</Td>
              </Row>
            );
          })}
        </tbody>
      </Table>
    </TableScroll>
  </Box>
);

export default CorpExcelUploadPreviewTable;
